const piWriterLogHu = {
	piWriterLogTable: 'PI Writer Log',
	timestamp: 'Timestamp',
	tag: 'Tag',
	objective: 'Objective',
	state: 'State',
	name: 'Name',
	piWriterLogEditForm: 'PI Writer Log',
	basic: 'Basic',
	tableName: 'Table Name',
	description: 'Description',
	fields: 'Fields',
	type: 'Type',
	userGroup: 'User Group'
};

export default piWriterLogHu;